import classNames from 'classnames';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
interface Props {
  isPinkBox: boolean;
}
export default function Skeleton({
  isPinkBox
}: Props) {
  const {
    isMobile
  } = useMobileDetect();
  const SkeletonItem = () => <div className={classNames('flex h-full flex-col items-center gap-1 rounded border border-border-gray-light bg-surface-solid-0 p-2 shadow-sm', 'w-[132px] min-w-[132px] lg:w-[252px] lg:min-w-[252px]')} data-sentry-component="SkeletonItem" data-sentry-source-file="skeleton.tsx">
            <div className={classNames('animate-pulse rounded bg-gray-100', 'h-30 w-30 lg:h-39 lg:w-39')}></div>
            <div className={classNames('h-5 w-full animate-pulse rounded bg-gray-100 lg:h-6', {
      hidden: isPinkBox
    })}></div>
            <div className='h-10 w-full animate-pulse rounded bg-gray-100 lg:h-12'></div>
            <div className={classNames('mr-auto mt-1 h-10 animate-pulse rounded bg-gray-100 lg:h-12', isPinkBox ? 'w-30' : 'w-25 lg:w-[168px]')}></div>
        </div>;
  return <div className={classNames('overflow-hidde absolute left-0 top-0 flex h-full w-full', 'min-h-[250px] gap-1.5 lg:min-h-[282px] lg:gap-2')} data-sentry-component="Skeleton" data-sentry-source-file="skeleton.tsx">
            {isPinkBox && <div className={classNames('h-full min-w-[122px] rounded bg-surface-solid-0 lg:min-w-[200px]', {
      hidden: isMobile
    })}></div>}
            {Array(7).fill(null).map((_, i) => <SkeletonItem key={i} />)}
        </div>;
}